<template>
  <pre v-show="false">
------------------------------------------------{br}
{{ data.store.name }}{br}
------------------------------------------------{br}
{{ data.customerName }}{br}
<template v-if="data.customerEmail">{{ data.customerEmail }}{br}</template>
<template v-if="data.customerPhone">{{ data.customerPhone }}{br}</template>
<template v-for="item in data.items">
------------------------------------------------{br}
{{ item.quantity }}x {{ item.productName }}{br}
<template v-for="choice in item.choices">
<template v-if="choice.type === 'OPTIONS_SINGLE_CHOICE'">
{{ choice.title }}: {{ choice.singleChoiceAnswer }}{br}
</template><template v-else-if="choice.type === 'OPTIONS_MULTIPLE_CHOICE'">
{{ choice.title }}: {{ choice.multipleChoiceAnswers.join(', ') }}{br}
</template><template v-else-if="choice.type === 'OPTIONS_REPEATABLE_CHOICE'">
{{ choice.title }}: {{ choice.repeatableChoiceAnswers.map(a => `${a.quantity}x ${a.description}`).join(', ') }}{br}
</template><template v-else-if="choice.type === 'TEXT'">
{{ choice.title }}: {{ choice.textAnswer }}{br}
</template>
</template>
{{ item.price | formatCurrency }}{br}
</template>
------------------------------------------------{br}
Qtd. itens: {{ data.items | sumItems }}{br}
{br}
<template v-if="data.feesToBeNegotiated">
Taxas a serem negociadas{br}
</template>
Subtotal: {{ data.subTotal | formatCurrency }}{br}
<template v-if="!data.feesToBeNegotiated">
Taxa de entrega: {{ data.deliveryFee | formatCurrency }}{br}
</template>
<template v-if="data.paymentMethodFee">
{{ data.paymentMethodFee > 0 ? "Taxa pagamento" : "Desconto" }}: {{ data.paymentMethodFee | formatCurrency }}{br}
</template>
<template v-if="!data.feesToBeNegotiated">
Total: {{ data.total | formatCurrency }}{br}
</template>
<template v-if="data.paymentMethod">
------------------------------------------------{br}
Pagamento: {{ data.paymentMethod }}{br}
<template v-if="data.paymentChangeFor">
Troco p/ {{ data.paymentChangeFor | formatCurrency }}
<template v-if="!data.feesToBeNegotiated">
&nbsp;({{ paymentChange | formatCurrency }})
</template>
{br}
</template>
</template>
<template v-if="data.type === 'DELIVERY'">
------------------------------------------------{br}
ENDEREÇO PARA DELIVERY{br}
{{ data.address.line1 }}{br}
Número: {{ data.address.houseNumber }}{br}
<template v-if="data.address.line2">Complemento: {{ data.address.line2 }}{br}</template>
Bairro: {{ data.address.level3 }}{br}
<template v-if="data.address.instructions">Referência: {{ data.address.instructions }}{br}</template>
</template>
<template v-if="data.type === 'PICKUP'">
-----------------------------------------------{br}
RETIRADA NO LOCAL{br}
</template>
------------------------------------------------{br}
Sequencial: {{ data.sequentialNumber }}{br}
Horário: {{ data.createdAt | formatDateTime }}{br}
{br}
Chave de identificação: {{ data.id }}{br}
  </pre>
</template>

<script>
import moment from "moment";

export default {
  name: 'OrderForPrinter',
  props: {
    data: {
      type: Object,
      required: true,
      default () {
        return {
          customer: {
            name: '',
            email: undefined,
            phone: undefined
          },
          address: {
            line1: '',
            houseNumber: '',
            line2: '',
            level3: '',
            instructions: ''
          },
          payment: {
            method: '',
            changeFor: 0,
            withoutChange: false
          },
          shoppingCart: {
            items: [],
            feesToBeNegotiated: false,
            subTotal: 0,
            deliveryFee: 0,
            total: 0
          }
        }
      }
    },
  },
  filters: {
    formatDateTime: function (date) {
      return moment(date).format("lll")
    },
    formatCurrency: function (number) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number)
    },
    sumItems: function (items) {
      return items.reduce((sum, item) => sum + item.quantity, 0)
    }
  },
  computed: {
    paymentChange () {
      return this.data.paymentChangeFor - this.data.total
    }
  },
  methods: {
    toText () {
      return this.$el.textContent.trim()
        .replace(/\n/g, '')
        .replace(/{br}/g, '\n')
    },
    toTextRaw () {
      return this.$el.textContent
    }
  }
}
</script>
